import { USER_DIALOG_ACTION_TYPES } from '../../constants/userDialog.constants';

const initialState = { open: false, dialogs: [], savedCount: 0, savedResult: null };

export default function PlaceDialogReducer(state = initialState, action) {
  switch (action.type) {
    case USER_DIALOG_ACTION_TYPES.SHOW_ADD_EDIT_PLACE:
      return {
        ...state,
        open: true,
        dialogs: [...state.dialogs, action.payload],
        savedResult: null,
      };

    case USER_DIALOG_ACTION_TYPES.HIDE_ADD_EDIT_PLACE: {
      const top = state.dialogs[state.dialogs.length - 1];
      if (!top || (action.payload.requestId && action.payload.requestId !== top.requestId))
        return state;
      const dialogs = state.dialogs.slice(0, -1);
      return { ...state, dialogs, open: dialogs.length > 0 };
    }

    case USER_DIALOG_ACTION_TYPES.PLACE_SAVED:
      return { ...state, savedCount: state.savedCount + 1, savedResult: action.payload };

    default:
      return state;
  }
}
